import { SearchResponse } from '@grpc-clients/external/mercury/v1/entertainment/entertainment.pb';
import { EntertainmentTicketState } from '.';
import {
  CLEAR_TICKETS_PAGINATION_RESULT,
  CLEAR_TICKET_EVENT_RESULT,
  EntertainmentTicketSearchActions,
  GET_TICKETS_PAGINATION_RESULT,
  GET_TICKETS_PAGINATION_RESULT_FAILURE,
  GET_TICKETS_PAGINATION_RESULT_SUCCESS,
  GET_TICKETS_SEARCH_RESULTS,
  GET_TICKETS_SEARCH_RESULTS_FAILURE,
  GET_TICKETS_SEARCH_RESULTS_SUCCESS,
  GET_TICKET_EVENT_RESULT_FAILURE,
  GET_TICKET_EVENT_RESULT_SUCCESS,
  UPDATE_TiCKET_FORM,
} from '../actions';

export const initialState: EntertainmentTicketState = {
  entertainmentTicketForm: null,
  loaded: false,
  loading: false,
  results: null,
  eventResult: null,
  paginationResponse: {
    results: [],
    isPageLoaded: true,
    isPageLoading: false,
  },
  pageIndex: 0,
};

export function reducer(state = initialState, action: EntertainmentTicketSearchActions): EntertainmentTicketState {
  switch (action.type) {
    case UPDATE_TiCKET_FORM:
      return {
        ...state,
        entertainmentTicketForm: action.formData,
      };

    case GET_TICKETS_SEARCH_RESULTS:
      return {
        ...state,
        loading: true,
        loaded: false,
      };

    case GET_TICKETS_SEARCH_RESULTS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        results: action.results,
      };

    case GET_TICKETS_SEARCH_RESULTS_FAILURE:
    case GET_TICKET_EVENT_RESULT_FAILURE:
    case CLEAR_TICKET_EVENT_RESULT:
    case GET_TICKETS_PAGINATION_RESULT_FAILURE:
    case CLEAR_TICKETS_PAGINATION_RESULT:
      return initialState;

    case GET_TICKET_EVENT_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        eventResult: action.result,
      };

    case GET_TICKETS_PAGINATION_RESULT:
      return {
        ...state,
        pageIndex: action.pageIndex,
        paginationResponse: {
          results: [],
          isPageLoaded: false,
          isPageLoading: true,
        },
      };

    case GET_TICKETS_PAGINATION_RESULT_SUCCESS: {
      const oldResults = state.results?.results || [];
      const newResults = action.results?.results || [];
      const newData = new SearchResponse({
        numberOfResults: state.results.numberOfResults, // Maintain other properties from state.results
        pageSize: state.results.pageSize,
        results: [...oldResults, ...newResults], // Merge results from state and action
        extendedResults: state.results.extendedResults,
        searchToken: state.results.searchToken,
      });

      return {
        ...state,
        results: newData,
        paginationResponse: {
          results: action.results?.results,
          isPageLoaded: true,
          isPageLoading: false,
        },
      };
    }

    default:
      return state;
  }
}
